var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{class:{ 'app-version-notice-open': _vm.versionNoticeVisible },attrs:{"id":"app"}},[_c('app-version-notice',{on:{"change":_vm.handleVersionNoticeChange}}),_c('keep-alive',{attrs:{"include":_vm.include,"max":20}},[_c('router-view',{key:_vm.$route.path})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }